export const TRACE_ID_HEADER = 'x-dr-trace-id';
export const SESSION_ID_HEADER = 'x-dr-session-id';
export const COX_AUTO_CORRELATION_ID_HEADER = 'X-CoxAuto-Correlation-Id';
